// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__fBOq8","contents":"styles_contents__l6_Iq","image":"styles_image__UbjqH","flipped":"styles_flipped__MLFVp"};